export const IS_TELEGRAM = 'isTelegram';
